import {TprmQuestionnaireModelId, TprmQuestionnaireTemplateId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const questionnaireTemplates = typedQuery(
  ["tprm", "questionnaireTemplates", param<TprmQuestionnaireModelId>("questionnaireModelId")],
  async questionnaireModelId => {
    return await api.tprm.questionnaireTemplates.list(questionnaireModelId);
  },
);

export const questionnaireTemplate = typedQuery(
  [
    "tprm",
    "questionnaireTemplate",
    param<TprmQuestionnaireModelId>("questionnaireModelId"),
    param<TprmQuestionnaireTemplateId>("questionnaireTemplateId"),
  ],
  async (questionnaireModelId, questionnaireTemplateId) => {
    return await api.tprm.questionnaireTemplates.get(questionnaireModelId, questionnaireTemplateId);
  },
);
